import { useDebouncedCallback } from '@mantine/hooks';
import { useCallback } from 'react';
import { DEBOUNCE_TIME } from '@/utils/constants.ts';

type DebouncedCallbackOptions =
  | number
  | {
      delay?: number;
      flushOnUnmount?: boolean;
    };

function useCustomDebouncedCallback<T extends (args: never) => void>(
  callback: T,
  deps: unknown[],
  options: DebouncedCallbackOptions = DEBOUNCE_TIME,
) {
  const debouncedOptions =
    typeof options === 'number' ? options : { ...options, delay: options.delay ?? DEBOUNCE_TIME };
  const memoizedCallback = useCallback(callback, [callback, ...deps]);
  return useDebouncedCallback(memoizedCallback, debouncedOptions);
}

export default useCustomDebouncedCallback;
